import { formatDateTime, imageSize } from "@converge-collective/common/util";
import { Avatar, Box, Paper, Typography } from "@mui/material";
import React from "react";
import { ChatMessage } from "@converge-collective/common/models/Chat";
import { useUser } from "reactfire";
import { formatRelative } from "date-fns";

export default function ChatMessageUI({
  chatMessage,
}: {
  chatMessage: ChatMessage;
}): React.ReactElement {
  const { data: user } = useUser();
  const isMine = user?.uid === chatMessage.from.id;
  return (
    <Box sx={{ overflowAnchor: "none" }}>
      <Typography
        sx={{
          my: 0.2,
          fontSize: 10,
          color: "#999",
          textAlign: "center",
          width: "100%",
        }}
        variant="body2"
      >
        {formatRelative(chatMessage.date, new Date())}
      </Typography>
      <Box display="flex" flexDirection={isMine ? "row-reverse" : "row"}>
        <Avatar
          sx={{ mt: 1, mr: 1 }}
          src={imageSize(chatMessage.from.photoURL, 600)}
        >
          <img
            style={{ maxWidth: "100%", maxHeight: "100%" }}
            src={chatMessage.from.photoURL}
          />
        </Avatar>
        <Box
          sx={{
            maxWidth: "75%",
            my: 1.4,
            mx: 0.5,
          }}
        >
          <Typography
            sx={{
              mt: -2,
              fontSize: 12,
              textAlign: isMine ? "right" : "left",
              fontWeight: "bold",
            }}
            variant="subtitle1"
          >
            {chatMessage.from.name}{" "}
          </Typography>
          <Paper
            sx={{
              backgroundColor: "#F3F3F3",
              boxShadow: "none",
              px: 0.6,
              py: 0.5,
              my: 0.2,
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                whiteSpace: "pre-line",
              }}
              variant="body1"
            >
              {chatMessage.body}{" "}
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}
